const TeamSection = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Thomas Morgan",
      role: "Founder, President, & Principal of Mortgage Management Systems",
      bio: "With over 20 years of experience in the mortgage industry, Thomas founded Mortgage Moat to protect financial institutions from evolving cyber threats.",
      image: "https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/2f25b0ca32107ccfa79baf20ea7bd241.png"
    },
    {
      id: 2,
      name: "Taylor Morgan",
      role: "Chief Information Security Officer",
      bio: "With over 7 years experience in tech/SaaS sales management, customer service and product engineering, Taylor Morgan is our CISSP expert.",
      image: "https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/e5fb555ec4154ba59ded223d0d868660.png"
    },
    {
      id: 3,
      name: "Ethan Houley",
      role: "Security Analyst",
      bio: "A gamer at heart, Ethan graduated from the University of Maryland with a degree in cybersecurity. He specializes in automation integrations, network mapping analysis, and penetration/vulnerability testing.",
      image: "https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/bb83634e11bf0e7016dcad5159fab93e.png"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
          Meet Our Team
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {teamMembers.map((member) => (
            <div key={member.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
              {/* Team Member Photo */}
              <div className="aspect-square bg-gray-200">
                {member.image ? (
                  <img 
                    src={member.image} 
                    alt={`${member.name} - ${member.role}`}
                    title={member.name}
                    className="w-full h-full object-cover object-top"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-gray-400">
                    <div className="text-center">
                      <i className="ri-user-line text-6xl mb-2"></i>
                      <p className="text-sm">[Team Photo]</p>
                    </div>
                  </div>
                )}
              </div>
              
              {/* Team Member Info */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">
                  {member.name}
                </h3>
                <p className="text-sm text-red-600 font-semibold mb-3">
                  {member.role}
                </p>
                <p className="text-gray-700 leading-relaxed">
                  {member.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
